'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const FunctionRowsIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.9,
        d: "M19.2 10.4H4.80005C4.20005 10.4 3.80005 9.99999 3.80005 9.39999V4.79999C3.80005 4.19999 4.20005 3.79999 4.80005 3.79999H19.3C19.9 3.79999 20.3 4.19999 20.3 4.79999V9.49999C20.2 9.99999 19.8 10.4 19.2 10.4ZM20.2001 19.2V14.5C20.2001 13.9 19.8 13.5 19.2 13.5H4.80005C4.20005 13.5 3.80005 13.9 3.80005 14.5V19.2C3.80005 19.8 4.20005 20.2 4.80005 20.2H19.3C19.8 20.2 20.2001 19.8 20.2001 19.2Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpFunctionRowsIcon = forwardRef(FunctionRowsIcon);

export { VpFunctionRowsIcon as default };
